export const LINKS = {
  TERMS_LINK: 'https://linearb.io/services-agreement/',
  PRIVACY_POLICY_LINK: 'https://linearb.io/privacy-policy/'
};
